module.exports = __webpack_public_path__ + "static/media/e4.e0f633af.png";